// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".l-sidebar[data-v-17d1c92a]{max-width:300px}.l-sidebar>.l-section>.l-ad__wrapper[data-v-17d1c92a]{margin-top:48px!important}.l-sidebar-mobile[data-v-17d1c92a]{display:none}@media (max-width:992px){.l-sidebar-mobile[data-v-17d1c92a]{display:block}}@media (max-width:992px){.l-sidebar[data-v-17d1c92a]{display:none}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
